class CollectionShowcase {
  constructor() {
    this.accordions = document.querySelectorAll('.accordion [data-accordion-item]');
    this.addToCartButtons = document.querySelectorAll('.cs-add-to-cart');
    this.isAddingToCart = false;
    this.init();
  }

  init() {
    this.initAccordions();
    this.initAddToCart();
    this.initCardNavigation();
  }

  initAccordions() {
    this.accordions.forEach(accordion => {
      const trigger = accordion.querySelector('[data-accordion-trigger]');
      const content = accordion.querySelector('[data-accordion-content]');
      
      if (!trigger || !content) return;

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        
        const isExpanded = accordion.getAttribute('data-expanded') === 'true';
        if (isExpanded) {
          // Si el activo es clickeado, replegar todos
          this.accordions.forEach(item => {
            this.closeAccordion(item);
          });
          return;
        }
        // Si no está activo, abrirlo y cerrar los demás
        this.accordions.forEach(item => {
          if (item !== accordion) {
            this.closeAccordion(item);
          }
        });
        this.openAccordion(accordion, trigger, content);
      });
    });
  }

  toggleAccordion(accordion, trigger, content) {
    const isExpanded = accordion.getAttribute('data-expanded') === 'true';
    
    this.accordions.forEach(item => {
      if (item !== accordion) {
        this.closeAccordion(item);
      }
    });
    
    if (isExpanded) {
      this.closeAccordion(accordion);
    } else {
      this.openAccordion(accordion, trigger, content);
    }
  }

  openAccordion(accordion, trigger, content) {
    accordion.setAttribute('data-expanded', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    content.style.maxHeight = content.scrollHeight + 'px';
  }

  closeAccordion(accordion) {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const content = accordion.querySelector('[data-accordion-content]');
    
    if (!trigger || !content) return;
    
    accordion.setAttribute('data-expanded', 'false');
    trigger.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = '0';
  }

  initAddToCart() {
    this.addToCartButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.handleAddToCart(e, button);
      });
    });
  }

  initCardNavigation() {
    const cards = document.querySelectorAll('.cs-product-card[data-variant-url]');

    cards.forEach((card) => {
      card.addEventListener('click', (e) => {
        const variantUrl = card.getAttribute('data-variant-url');
        if (!variantUrl) return;

        const interactiveElement = e.target.closest('a, button, input, select, textarea, summary, [role="button"], [data-accordion-trigger], .cs-add-to-cart');
        if (interactiveElement) return;

        window.location.href = variantUrl;
      });
    });
  }

  async handleAddToCart(e, button) {
    console.log('Add to cart button clicked!', button);
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    if (!button) return;
    
    if (this.isAddingToCart) {
      console.log('Already adding to cart, ignoring duplicate call');
      return;
    }
    
    const variantId = button.getAttribute('data-product-id');
    const sellingPlanId = button.getAttribute('data-selling-plan-id');
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    this.isAddingToCart = true;
    button.disabled = true;
    button.classList.add('loading');
    const originalText = button.innerHTML;
    button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M19 9.5C19 11.28 18.4722 13.0201 17.4832 14.5001C16.4943 15.9802 15.0887 17.1337 13.4442 17.8149C11.7996 18.4961 9.99002 18.6743 8.24419 18.3271C6.49836 17.9798 4.89471 17.1226 3.63604 15.864C2.37737 14.6053 1.5202 13.0016 1.17293 11.2558C0.825665 9.50998 1.0039 7.70038 1.68508 6.05585C2.36627 4.41131 3.51983 3.00571 4.99987 2.01677C6.47991 1.02784 8.21997 0.5 10 0.5" stroke="#2E2E24"/></svg>';

    try {
      const payload = {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const result = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:update-counter'));
      
      document.dispatchEvent(new CustomEvent('cart:refresh-open'));
      
      setTimeout(() => {
        button.classList.remove('loading');
        button.innerHTML = '✓ Added!';
        
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
          this.isAddingToCart = false;
        }, 1000);
      }, 1000);
      
    } catch (error) {
      console.error('[Collection Showcase] Add to cart error:', error);
      alert('Error adding to cart. Please try again.');
      button.classList.remove('loading');
      button.innerHTML = originalText;
      button.disabled = false;
      this.isAddingToCart = false;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionShowcase();
  });
} else {
  new CollectionShowcase();
}
